// 語言切換按鈕

import Image from 'next/image';

const ToggleLanguageButton = ({ dispatch, setShowLanguageModal }) => {
    // 點擊語言切換
    const onLanguageChange = () => dispatch(setShowLanguageModal(true));

    return (
        <button
            className="group hover:bg-[rgba(255,255,255,.3)] hover:border-opacity-[1] ulg:hidden"
            onClick={onLanguageChange}
        >
            <Image
                className="group-hover:filter-white"
                src="/images/icon/icon_language.svg"
                width={16}
                height={16}
                alt="language_icon"
            />
        </button>
    );
};

export default ToggleLanguageButton;
